export default __webpack_public_path__ + "static/media/regular.ad037553.woff2";